<template>
<!-- 二三级页面的一级导航栏 -->
    <div style="width:100%;display:flex;height:64px">
      <div class="d-flex align-center" to="/">
        <v-img alt="Vuetify Name" class="shrink mt-1 hidden-sm-and-down" contain min-width="100"
          width="100"
        />
        <!-- logo -->
        <v-img alt="Vuetify Logo" class="shrink mr-2 cursor" contain src="../assets/images/logo.png"
          transition="scale-transition"
          width="40"
          style="margin-left:30px;cursor:pointer"
          @click="toguid('/','videoBox')"
        />
        <!-- logo文字 -->
        <v-img alt="Vuetify Name" class="shrink mt-1 hidden-sm-and-down" contain min-width="100"
          src="../assets/images/logo_text.png"
          style='cursor:pointer'
          width="100"
          @click="toguid('/','videoBox')"
        />
      </div>
      <!-- 导航项 -->
      <v-tabs right v-model="first_active_tab" :background-color='barColor' color="white" height="64" v-if="pc">
        <v-tab v-for="tab of firstTabs" :key="tab.id" @click="toguid('/',tab.name)" class="body_text">
        {{tab.label}}
        </v-tab>
        <v-tab disabled></v-tab>
      </v-tabs>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" v-else></v-app-bar-nav-icon>
      <v-navigation-drawer
        v-model="drawer"
        absolute
        temporary
        overlay-color='rgba(1,1,1,0)'
        style="background-color:var(--secondary)"
      >
        <v-list
          nav
          dense
        >
          <v-list-item-group
            v-model="group"
            active-class="text--accent-4"
          >
            <v-list-item v-for="tab of firstTabs" :key="tab.id" @click="toguid('/',tab.name)">
              <v-list-item-title>{{tab.label}}</v-list-item-title>
            </v-list-item>

          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </div>
</template>

<script>
export default {
  name: 'FirstNavbar',

  props: {
    // 当前一级导航选项卡
    tab_index: Number,
    // 导航栏是否隐藏
    barHide: Boolean,
    barColor: String,
    pc: Boolean
  },

  data: () => ({
    drawer: false,
    group: null,
    // 一级导航选项卡
    first_active_tab: Number,
    firstTabs: [
      { id: 1, name: 'aboutUs', label: '关于我们' },
      { id: 2, name: 'dataCenter', label: '数据中心' },
      { id: 3, name: 'platform', label: '大数据平台' },
      { id: 4, name: 'products', label: '软件服务' },
      { id: 5, name: 'cloud', label: '云服务' },
      { id: 6, name: 'media', label: '新闻中心' },
      { id: 7, name: 'contact', label: '联系我们' }
    ]
  }),

  watch: {
    group () {
      this.drawer = false
    }
  },

  mounted () {
    this.first_active_tab = this.tab_index
  },

  methods: {
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    }
  }
}
</script>
